import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PaperForm from 'ui/form/PaperForm';

import { getActionButtons } from './FormButtons';
import { withStyles } from '@material-ui/core';
import { isValidConnector } from '../Consts';

const styles = () => ({
    actions: {
        marginTop: 8,
    },
    formBody: {
        minHeight: 400,
    },
});

const VIEW_MODE = 'view';
const EDIT_MODE = 'edit';
const DETAIL_MODE = 'details';

function createTabState(tabs) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [lock, setLock] = useState(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [tab, setTab] = useState(tabs[0]);
    const first = tabs[0];
    const last = tabs[tabs.length - 1];

    return {
        get current() {
            return tab;
        },
        map(fn) {
            return tabs.map(fn);
        },
        setByName(name) {
            setTab(tabs.find(tab => tab.name === name));
        },
        setNext() {
            if (!lock) {
                for (let i = 0; i < tabs.length; i += 1) {
                    if (tabs[i].name === tab.name && tabs[i + 1]) {
                        setTab(tabs[i + 1]);
                        break;
                    }
                }
            }
        },
        setPrev() {
            for (let i = 0; i < tabs.length; i += 1) {
                if (tabs[i].name === tab.name && tabs[i - 1]) {
                    setTab(tabs[i - 1]);
                    break;
                }
            }
        },
        lock() {
            setLock(true);
        },
        unlock() {
            setLock(false);
        },
        get locked() {
            return lock;
        },
        get isLast() {
            return tab === last;
        },
        get isFirst() {
            return tab === first;
        },
    };
}

function BaseForm({ config, connector, onAction, mode }) {
    const [values, setValues] = useState({
        rules: [],
        extra: { ...connector.extra },
    });
    const [changes, setChanges] = useState(false);
    const tabs = createTabState(config.tabs);
    const isValid = isValidConnector({ ...connector, ...values });
    const { identifier } = connector;
    const onChange = (name, value) => {
        let data = null;
        if (name === 'rules') {
            data = value.concat([]);
        } else if (name === 'extra') {
            data = { ...values.extra, ...value };
        }
        if (data !== null) {
            setValues({ ...values, [name]: data });
            setChanges(true);
        }
    };
    const getActions = () => {
        const ActionsComponent = getActionButtons(mode);
        return (
            <ActionsComponent
                identifier={identifier}
                isValid={isValid}
                tabs={tabs}
                values={values}
                changes={changes}
                onAction={onAction}
            />
        );
    };
    const TabComponent = tabs.current.component;
    return (
        <PaperForm title={config.name}>
            <Tabs
                value={tabs.current.name}
                onChange={(event, name) =>
                    mode !== VIEW_MODE && isValid && tabs.setByName(name)
                }
                textColor="secondary"
            >
                {tabs.map(tab => (
                    <Tab key={tab.name} label={tab.label} value={tab.name} />
                ))}
            </Tabs>
            <FormBody>
                <TabComponent
                    mode={mode}
                    name={tabs.current.name}
                    shortName={config.shortName}
                    tabs={tabs}
                    values={values}
                    isValid={isValid}
                    connector={connector}
                    onAction={onAction}
                    onChange={onChange}
                />
            </FormBody>
            <Actions>{getActions()}</Actions>
        </PaperForm>
    );
}

const FormBody = withStyles(styles)(({ children, classes }) => (
    <div className={classes.formBody}>{children}</div>
));

const Actions = withStyles(styles)(({ classes, children }) => (
    <div className={classes.actions}>{children}</div>
));

export const ViewForm = props => <BaseForm {...props} mode={VIEW_MODE} />;

export const EditForm = props => <BaseForm {...props} mode={EDIT_MODE} />;

export const DetailsForm = props => <BaseForm {...props} mode={DETAIL_MODE} />;
